module.exports = __webpack_public_path__ + "img/how_shop_4.93972787.png";